import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface RuntimeConfig {
  hmacKey: string;
}

@Injectable({
  providedIn: 'root'
})
export class RuntimeConfigService {
  private config: RuntimeConfig | null = null;

  constructor(private readonly http: HttpClient) {}

  /**
   * Loads the runtime configuration from the JSON file generated at container startup.
   * This is called during app initialization via provideAppInitializer.
   */
  async loadConfig(): Promise<void> {
    try {
      const config = await firstValueFrom(
        this.http.get<RuntimeConfig>('/assets/runtime-config.json')
      );
      this.config = config;
      console.log('Runtime config loaded successfully');
    } catch (error) {
      console.warn('Failed to load runtime config, falling back to environment config:', error);
      this.config = null;
    }
  }

  /**
   * Returns the HMAC key from runtime config.
   * Returns null if runtime config was not loaded (falls back to environment).
   */
  getHmacKey(): string | null {
    return this.config?.hmacKey ?? null;
  }

  /**
   * Returns the full runtime config object.
   */
  getConfig(): RuntimeConfig | null {
    return this.config;
  }
}